/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

interface RoleBadgeProps {
  role: 'User' | 'Chatbot';
}

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role }) => {
  const isUser = role === 'User';
  
  return (
    <span css={badgeStyles(isUser)} title={role}>
      <span css={dotStyles(isUser)} />
      {role}
    </span>
  );
};

const badgeStyles = (isUser: boolean) => css`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border-radius: 1rem;
  padding: 0.2rem 0.8rem;
  font-size: 1.2rem;
  border: 1px solid ${isUser ? '#93c5fd' : '#86efac'};
  background: ${isUser ? '#dbeafe' : '#dcfce7'};
  color: ${isUser ? '#1e40af' : '#166534'};
`;

const dotStyles = (isUser: boolean) => css`
  height: 0.6rem;
  width: 0.6rem;
  border-radius: 50%;
  background: ${isUser ? '#3b82f6' : '#10b981'};
`;